<div class="page-header">
  <h2>Contact Us</h2>
</div>

<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<div class="container pt-24">

  <div class="contact-main">

    <!-- LEFT IMAGE -->
    <div class="contact-image">
      <img src="assets/contact_us.jpg" alt="Contact Us" />
    </div>

    <!-- RIGHT CONTENT -->
    <div class="contact-content">

      <section>
        <h3>Need help with your self-service immunization voucher account? Walgreens is here to help.</h3>
        <p>
          Before contacting support, we encourage you to review the FAQ page for answers to common questions about
          account setup, contracts, voucher access, and website use.
        </p>
        <p>
          If you have questions about setting up your account, completing your contract, invoicing, voucher access,
          or using the website, please contact us by email at
          <a href="mailto:vaccines@walgreens.com">vaccines&#64;walgreens.com</a>
        </p>
      </section>

      <section>
        <h3>Need Help Choosing Vaccines?</h3>
        <p>
          If you have questions about which vaccines may be right for your organization, please contact your
          <a href="https://www.walgreens.com/storelocator/find.jsp" target="_blank" rel="noopener noreferrer">
            Walgreens
          </a>
          store directly. A Walgreens pharmacist or healthcare team member can help review your
          organization’s needs and discuss available vaccination voucher program options.
        </p>
      </section>

      <section>
        <h3>Email Support</h3>
        <p class="support-label">For assistance, please email:</p>
        <p class="email-link-row">
          <a href="mailto:vaccines@walgreens.com">vaccines&#64;walgreens.com</a>
        </p>

        <p class="support-label">You can contact us for help with:</p>
        <ul>
          <li>Account setup</li>
          <li>Contract completion</li>
          <li>Invoicing and billing</li>
          <li>Voucher access and use</li>
        </ul>
      </section>

      <section>
        <h3>To Help Us Assist You Faster</h3>
        <p>
          If possible, please email us from the same email address used to create your account. This helps us locate
          your account more quickly. If you are contacting us from a different email address, please include the email
          associated with the account in your message.
        </p>

        <ul>
          <li>Organization name</li>
          <li>Contact name</li>
          <li>Email address and/or phone number</li>
          <li>Type of issue</li>
          <li>Invoice number or voucher group ID</li>
          <li>A brief description of the issue</li>
          <li>Screenshots</li>
        </ul>
      </section>

      <section>
        <h3>Important Information</h3>

        <p class="bold-note">Privacy Notice</p>
        <p class="bold-note">
          Please do not include confidential or sensitive information in your email, such as medical or prescription
          information, Social Security numbers, or credit card numbers.
        </p>
      </section>

      <section>
        <h3>What to Expect</h3>
        <p class="bold-note">
          After you email us, your request will be routed to the appropriate support team for review. If additional
          information is needed, a representative may follow up using the contact information you provide.
        </p>
      </section>
    </div>
  </div>
</div>

<!-- CLOSE BUTTON -->
<div class="faq-close-container">
  <button class="button-primary" (click)="onClose()">Close</button>
</div>